// The action library and the zone-pattern labels on screen. The English texts in
// prioritization/settings.js (ACTION_LIBRARY, PATTERN_META) are DATA: pickActions()
// dedupes on them, they are generated into prioritization_config.json for the
// backend and the parity tests compare them, so they never change. Only what the
// reader SEES goes through here. English shows the same text as always; Dutch
// reuses the backend's wording (applicaite/i18n/signals_nl.py ACTION_NL /
// PATTERN_NL) and docs/reference/dutch_glossary.md §4.
import { i18n } from './index.js'

// English text -> key under actionLibrary.items, built once from the English file
// (the English file mirrors settings.js; actions.spec.js checks it stays that way).
let _keyByText = null
function keyByText() {
  if (_keyByText) return _keyByText
  _keyByText = {}
  const items = (i18n.global.getLocaleMessage('en').actionLibrary || {}).items || {}
  for (const [group, list] of Object.entries(items)) {
    for (const [n, item] of Object.entries(list)) {
      if (item && item.text) _keyByText[item.text] = `actionLibrary.items.${group}.${n}`
    }
  }
  return _keyByText
}

// actionText('Move nearer main aisle') -> 'Move nearer main aisle' | 'Dichter bij het hoofdpad zetten'.
// Unknown texts show as given.
export function actionText(english) {
  const key = keyByText()[english]
  return key ? i18n.global.t(`${key}.text`) : english
}

// The library's hint for an action, by its English TEXT (the hint's own English
// shows when the text is unknown).
export function actionHint(englishText, englishHint = '') {
  const key = keyByText()[englishText]
  return key ? i18n.global.t(`${key}.hint`) : englishHint
}

// patternText('awareness', 'chip' | 'legend' | 'plain'). Unknown kind/field -> ''.
export function patternText(kind, field) {
  const key = `actionLibrary.pattern.${kind}.${field}`
  return i18n.global.te(key, 'en') ? i18n.global.t(key) : ''
}
